import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import * as React from 'react';
import { cn } from '@/utils/style';

export function Checkbox({
  className,
  variant = 'default',
  ...props
}: Omit<React.ComponentProps<typeof CheckboxPrimitive.Root>, 'onChange'> & {
  variant?: 'default' | 'error';
}) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer border-gray-300 dark:bg-input/30 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        variant === 'default' &&
          'data-[state=checked]:bg-pink-600 data-[state=checked]:border-pink-600 dark:data-[state=checked]:bg-pink-600',
        variant === 'error' &&
          'data-[state=checked]:bg-red-600 data-[state=checked]:text-red-600-foreground dark:data-[state=checked]:bg-red-600 data-[state=checked]:border-red-600',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-white transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
